import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.scss";
import Button from "/components/common/button";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";

export default function LandingBottom() {
  const { product } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  return (
    <div className={styles.Info}>
      <div className="container">
        <br />
        <h2 id="description">Описание</h2>

        <div>
          {product.DETAIL_TEXT ? (
            <div className={"text"}>
              <div
                itemProp="description"
                dangerouslySetInnerHTML={{ __html: product.DETAIL_TEXT }}
              ></div>
            </div>
          ) : (
            <div>
              <p>
                Нет описания. Если у вас появились вопросы по товару - закажите
                обратный звонок:
              </p>
              <div>
                <Button
                  customStyles={styles.FormButton}
                  onClick={() => dispatch(showPopup(popupTypes.backCall))}
                  label={"Заказать звонок"}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
